import $ from "jquery";
import {isMobile} from "./browser";

export const loadApp = () => {
  console.log("loading", {isMobile});
};



// WEBPACK FOOTER //
// ./src/lib/opener.ts